// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-pages-guide-authSuccess-__index__wrap--2KLtT","tip":"src-pages-guide-authSuccess-__index__tip--e0ysM"};